import React from 'react';
import { cloneDeep } from 'lodash';
import InputMask from 'react-input-mask';
import withStyles from 'react-jss';
import { withRouter } from 'react-router-dom';
import Truncate from 'react-truncate';
import { connect } from 'react-redux';
import { RadioGroup, RadioButton } from 'react-custom-radio';
import { Translation } from 'react-i18next';
import i18n from 'i18next';
import {
  getAuthState,
  getEcapState,
  getOnboardingState,
} from '../../store/selectors';
import { saveEcap, getEcap, setEcap } from '../../store/actions';
import ErrorMessage from '../ErrorMessage';
import validate from '../utility/CheckError';
import ComponentHeader from './ComponentHeader';
import ToolTipIcon from '../utility/ToolTipIcon';
import DeleteIcon from '../utility/DeleteIcon';
import { activityCopy } from '../../copy/activityCopy.json';

const continueButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant ? props.tenant.primary : 'white',
    borderColor: props.tenant ? props.tenant.primary : 'black',

    '&:hover': {
      backgroundColor: 'white',
      border: props.tenant
        ? `2px solid ${props.tenant.primary}`
        : '2px solid black',
      color: props.tenant ? props.tenant.primary : 'black',
      borderStyle: 'solid',
    },
  }),
};

export class AdditionalActivities extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      activityTitle: '',
      duration: '',
      category: '',
      Extracurricular: [],
      Work: [],
      Volunteer: [],
      Achievement: [],
      errors: {
        activityTitle: false,
        duration: false,
      },
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.props.getEcap(this.props.auth.jwtToken);

    const plan = this.props.location.pathname.includes('user-profile')
      ? this.props.ecapPlan
      : this.props.ecap.plan;

    this.setState({
      Extracurricular: plan.Extracurricular ? plan.Extracurricular : [],
      Work: plan.Work ? plan.Work : [],
      Volunteer: plan.Volunteer ? plan.Volunteer : [],
      Achievement: plan.Achievement ? plan.Achievement : [],
    });
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  get activityTypesInfo() {
    return {
      extracurricular: {
        label: i18n.t('Extracurricular'),
        tip: i18n.t(
          'Examples include being on a sports team, joining a club, student government, etc.'
        ),
        example: i18n.t('Ex: Soccer', { context: 'Example' }),
        key: 'Extracurricular',
      },
      work: {
        label: i18n.t('Work'),
        tip: i18n.t(
          'Examples include a part-time job, internships, job-shadowing, etc.'
        ),
        example: i18n.t('Ex: Barista', { context: 'Example' }),
        key: 'Work',
      },
      volunteer: {
        label: i18n.t('Volunteer'),
        tip: i18n.t(
          'Examples include community service, tutoring/mentoring, fundraising activities, etc.'
        ),
        example: i18n.t('Ex: Habitat For Humanity', { context: 'Example' }),
        key: 'Volunteer',
      },
      achievement: {
        label: i18n.t('Achievement'),
        labelPlural: i18n.t('Achievements'),
        tip: i18n.t(
          'Examples include earning an award, lettering, making honor roll, etc.'
        ),
        example: i18n.t('Ex: Lettered in Soccer', { context: 'Example' }),
        key: 'Achievement',
      },
    };
  }

  handleRadioChange = (category) => {
    if (this._isMounted) {
      this.setState({ category });
    }
  };

  radioGroup = (options) => {
    const { primary } = this.props.tenant;
    const primaryColor = {
      background: `${primary}`,
    };
    const primaryBorder = {
      border: `1px solid ${primary}`,
    };
    const labelStyle = {
      color: `${primary}`,
    };
    const radioGroups = [];

    options.forEach((option) => {
      const { label, tip } = option;
      const selected = this.state.category === label;

      radioGroups.push(
        <div className="radio-input-container" key={label}>
          <span
            className={selected ? 'radio-fill' : 'radio-fill hidden'}
            style={primaryColor}
          />
          <RadioButton
            role="radio"
            value={label}
            aria-checked={selected}
            className="radio-button"
            useHiddenInput
            style={primaryBorder}
            aria-labelledby={label}
          />
          <label
            className={selected ? 'category-label checked' : 'category-label'}
            style={labelStyle}
            id={label}
          >
            {label}
          </label>
          <button
            type="button"
            className="tooltip-div"
            aria-describedby={`${label}-tip-description`}
            onClick={() => {
              this.setState({
                [`display${label}Tip`]: true,
              });
            }}
            onFocus={() => {
              this.setState({
                [`display${label}Tip`]: true,
              });
            }}
            onBlur={() => {
              this.setState({
                [`display${label}Tip`]: false,
              });
            }}
          >
            <ToolTipIcon
              color={this.props.tenant.primary}
              tooltip={tip}
              ariaLabel={`Additional information: ${tip}`}
              showToolTip={this.state[`display${label}Tip`]}
            />
          </button>
        </div>
      );
    });

    return (
      <RadioGroup
        name="category"
        className="radio-inputs"
        role="radiogroup"
        selectedValue={this.state.category}
        onChange={this.handleRadioChange}
      >
        {radioGroups}
      </RadioGroup>
    );
  };

  deleteActivity = (title, index) => {
    this.setState(
      (prevState) => {
        const correctedTitle = title[0].toUpperCase() + title.substring(1);
        const newArray = prevState[correctedTitle];

        newArray.splice(index, 1);
        return {
          ...prevState,
          [correctedTitle]: newArray,
        };
      },
      () => {
        this.submitAllActivities();
      }
    );
  };

  activitySection = (title, stateTitle, exampleText, activities) => {
    const { primary, secondary } = this.props.tenant;
    const secondaryColorBar = {
      backgroundColor: `${secondary}`,
    };
    const lowerTitle = stateTitle.toLowerCase();

    if (!activities.length) {
      return (
        <div className="activity-section">
          <h3>{title}</h3>
          <div className="underline" style={secondaryColorBar} />
          <div className="submission-container">
            <div className="submission">
              <p className="label sample">{exampleText}</p>
              <p className="duration sample">{activityCopy.exampleDuration}</p>
            </div>
          </div>
        </div>
      );
    }

    const submissionArray = [];

    activities.forEach((activity, index) => {
      submissionArray.push(
        <div className="submission" key={`${Math.random()}${activity.title}`}>
          {!this.props.location.pathname.includes('user-profile') && (
            <DeleteIcon
              color={primary}
              delete={() => {
                this.deleteActivity(lowerTitle, index);
              }}
            />
          )}
          <p className="label">
            <Truncate lines={3} ellipsis="...">
              {activity.title}
            </Truncate>
          </p>
          <p className="duration">{activity.duration}</p>
        </div>
      );
    });

    return (
      <div className="activity-section">
        <h3>{title}</h3>
        <div className="underline" style={secondaryColorBar} />
        <div className="submission-container">{submissionArray}</div>
      </div>
    );
  };

  handleErrors = async (event, inputValue) => {
    event.persist();

    const errorsCopy = cloneDeep(this.state.errors);
    const stateCopy = cloneDeep(this.state);
    const checkEmailExists =
      event.target.id === 'new-email'
        ? await this.props.checkUser(inputValue)
        : false;
    const error = await validate(
      event.target.id,
      inputValue,
      errorsCopy,
      stateCopy,
      checkEmailExists
    );

    if (this._isMounted) {
      this.setState(() => ({
        errors: { ...error },
      }));
    }
  };

  getDynamicButton = () => {
    const temporaryValid = true;

    return temporaryValid ? this.props.classes.color : null;
  };

  buttonisDisabled = () => {
    const { activityTitle, duration, category } = this.state;

    if (!activityTitle || !duration || !category) {
      return true;
    }

    return false;
  };

  submitNewActivity = () => {
    if (this._isMounted) {
      const { activityTitle, duration, category } = this.state;
      const newActivity = {
        category,
        title: activityTitle,
        duration,
      };

      this.setState(
        (prevState) => ({
          [category]: [...prevState[category], newActivity],
          activityTitle: '',
          duration: '',
          category: '',
        }),
        () => {
          this.submitAllActivities();
        }
      );
    }
  };

  onInputChange = async (event) => {
    event.persist();

    if (this._isMounted) {
      this.setState({
        [event.target.id]: event.target.value,
      });
    }
  };

  saveProgress = async () => {
    const plan = cloneDeep(this.props.ecap.plan);
    const { Extracurricular, Work, Volunteer, Achievement } = this.state;
    const newActivities = Extracurricular.concat(Work, Volunteer, Achievement);

    plan.Extracurricular = Extracurricular;
    plan.Work = Work;
    plan.Volunteer = Volunteer;
    plan.Achievement = Achievement;
    plan.newActivities = newActivities;
    await this.props.setEcap(plan);
  };

  submitAllActivities = async () => {
    const plan = cloneDeep(this.props.ecap.plan);
    const { Extracurricular, Work, Volunteer, Achievement } = this.state;
    const newActivities = Extracurricular.concat(Work, Volunteer, Achievement);

    plan.Extracurricular = Extracurricular;
    plan.Work = Work;
    plan.Volunteer = Volunteer;
    plan.Achievement = Achievement;
    plan.newActivities = newActivities;
    await this.props.saveEcap(this.props.auth.jwtToken, plan);
  };

  get dateRangePlaceholder() {
    return `${i18n.t('MM/YYYY', { context: 'Date and Time' })} - ${i18n.t(
      'MM/YYYY',
      {
        context: 'Date and Time',
      }
    )}`;
  }

  render() {
    const { primary } = this.props.tenant;
    const {
      activityTitle,
      duration,
      errors,
      Extracurricular,
      Work,
      Volunteer,
      Achievement,
    } = this.state;

    const labelActivityTextPrimary = {
      color: `${primary}`,
    };

    return (
      <Translation>
        {(t) => (
          <div id="additional-activities">
            <ComponentHeader
              parent="ecap"
              appendText="additionalActivities"
              headerText={
                this.props.location.pathname.includes('user-profile')
                  ? t('Additional Activities')
                  : t('Add Your Additional Activities')
              }
              subheadingText={
                this.props.location.pathname.includes('user-profile')
                  ? ''
                  : t(
                      'Additional activities include extracurricular involvement, work experience, volunteer work, and personal achievements. Enter the Activity into the first field and the year your experience took place, then select the category your activity falls under.'
                    )
              }
              tenant={this.props.tenant}
              marginTop="0px !important"
            />
            {!this.props.location.pathname.includes('user-profile') && (
              <div className="custom-activity">
                <div className="activity-form-row">
                  <div className="form-label-error-input">
                    <div className="label-and-error">
                      <label
                        className="label-activity activity-form-column"
                        htmlFor="activityTitle"
                        style={labelActivityTextPrimary}
                      >
                        {t('Activity')}
                      </label>
                      <div
                        className="error-activityTitle"
                        id="activityTitle-error"
                        aria-live="assertive"
                      >
                        <span
                          style={{
                            display: errors.activityTitle ? '' : 'none',
                          }}
                        >
                          <ErrorMessage error={t('Field required')} />
                        </span>
                      </div>
                    </div>
                    <input
                      onBlur={(event) => {
                        this.handleErrors(event, this.state.activityTitle);
                      }}
                      type="text"
                      onChange={this.onInputChange}
                      value={activityTitle}
                      placeholder={t('Name or Title')}
                      className={
                        errors.activity
                          ? 'form-activity error'
                          : 'form-activity'
                      }
                      id="activityTitle"
                      aria-labelledby="activityTitle-error"
                    />
                  </div>
                  <div className="form-label-error-input">
                    <div className="label-and-error">
                      <label
                        className="label-activity activity-form-column"
                        htmlFor="duration"
                        style={labelActivityTextPrimary}
                      >
                        {t('Date', { context: 'Date and Time' })}
                      </label>
                      <span
                        id="duration-error"
                        style={{ display: errors.duration ? '' : 'none' }}
                      >
                        <ErrorMessage error={t('Field required')} />
                      </span>
                    </div>
                    <InputMask
                      placeholder={this.dateRangePlaceholder}
                      id="duration"
                      className={
                        errors.activity
                          ? 'form-activity error'
                          : 'form-activity'
                      }
                      mask="99/9999 - 99/9999"
                      maskPlaceholder={this.dateRangePlaceholder}
                      onChange={this.onInputChange}
                      value={duration}
                      onBlur={(event) => {
                        this.handleErrors(event, this.state.duration);
                      }}
                    />
                  </div>
                </div>
                <div className="activity-form-row bottom">
                  {this.radioGroup([
                    {
                      label: this.activityTypesInfo.extracurricular.label,
                      tip: this.activityTypesInfo.extracurricular.tip,
                    },
                    {
                      label: this.activityTypesInfo.work.label,
                      tip: this.activityTypesInfo.work.tip,
                    },
                    {
                      label: this.activityTypesInfo.volunteer.label,
                      tip: this.activityTypesInfo.volunteer.tip,
                    },
                    {
                      label: this.activityTypesInfo.achievement.label,
                      tip: this.activityTypesInfo.achievement.tip,
                    },
                  ])}
                  <div className="add-button-container">
                    <button
                      disabled={this.buttonisDisabled()}
                      type="submit"
                      className={[
                        'button--primary',
                        this.getDynamicButton(),
                      ].join(' ')}
                      id="add-button"
                      onClick={this.submitNewActivity}
                    >
                      {t('Add')}
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div
              className={
                this.props.location.pathname.includes('user-profile')
                  ? 'activities-container user-profile'
                  : 'activities-container'
              }
            >
              {this.activitySection(
                this.activityTypesInfo.extracurricular.label,
                this.activityTypesInfo.extracurricular.key,
                this.activityTypesInfo.extracurricular.example,
                Extracurricular
              )}
              {this.activitySection(
                this.activityTypesInfo.work.label,
                this.activityTypesInfo.work.key,
                this.activityTypesInfo.work.example,
                Work
              )}
              {this.activitySection(
                this.activityTypesInfo.volunteer.label,
                this.activityTypesInfo.volunteer.key,
                this.activityTypesInfo.volunteer.example,
                Volunteer
              )}
              {this.activitySection(
                this.activityTypesInfo.achievement.labelPlural,
                this.activityTypesInfo.achievement.key,
                this.activityTypesInfo.achievement.example,
                Achievement
              )}
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const ecap = getEcapState(state);
  const auth = getAuthState(state);
  const onboarding = getOnboardingState(state);
  return { ecap, auth, onboarding };
};

const AdditionalActivitiesWithRouter = withRouter(
  connect(mapStateToProps, {
    getEcap,
    saveEcap,
    setEcap,
  })(withStyles(continueButtonStyles)(AdditionalActivities))
);

export default AdditionalActivitiesWithRouter;
